export default {
  methods: {
    convertObjectArray(items, key){
      return items.map(item => item[key])
    },
    appendArray(items, name, data){
      if(items.length == 0){
        data.append(`${name}`, [] )
      } else {
        items.map((value, key) => {
          data.append(`${name}[${key}]`, value )
        })
      }
    }
  }
}
